import { CSS3DObject } from "three/examples/jsm/renderers/CSS3DRenderer.js";
import { Collection } from "../Campaigns/Collection";
import { CreationCommandTypes, ExecutionStatus } from "../DomainEntity";
import { SectionElement } from "./SectionElement";


export abstract class NonWorkableElement extends SectionElement {

    public label
    public createdAt

    private _campaign: Collection;
    public get Campaign(): Collection {
        return this._campaign;
    }
    public set Campaign(v: Collection) {
        if (v) {
            this._campaign = v;
        }
    }

    private _css3dObject : CSS3DObject;
    public get css3dObject() : CSS3DObject {
      return this._css3dObject;
    }
    public set css3dObject(v : CSS3DObject) {
      this._css3dObject = v;
    }

    private _tempCollectionId: string;
    public get tempCollectionId(): string {
        return this._tempCollectionId;
    }
    public set tempCollectionId(v: string) {
        this._tempCollectionId = v;
    }

    public get CampaignId(): string {
        return this._campaign.Guid;
    }

    public get collectionId(): string {
        return this._campaign.CollectionInfoModel.TempCollectionId;
    }

    private _deathDate: Date;
    public get DeathDate(): Date {
        return this._deathDate;
    }
    public set DeathDate(v: Date) {
        this._deathDate = v;
    }

    private _date: Date;
    public get date(): Date {
        return this._date;
    }
    public set date(v: Date) {
        this._date = v;
    }

    private _creationCommandType: CreationCommandTypes;
    public get CreationCommandType(): CreationCommandTypes {
        return this._creationCommandType;
    }
    public set CreationCommandType(v: CreationCommandTypes) {
        this._creationCommandType = v;
    }

    private _regionId: string;
    public get regionId(): string {
        return this._regionId;
    }
    public set regionId(v: string) {
        this._regionId = v;
    }


    private _regionIds: Array<string>;
    public get regionIds(): Array<string> {
        return this._regionIds;
    }
    public set regionIds(v: Array<string>) {
        this._regionIds = v;
    }

    private _properties: any;
    public get properties(): any {
        return this._properties;
    }
    public set properties(v: any) {
        this._properties = v;
    }

    private _regionName: string;
    public get regionName(): string {
        return this._regionName;
    }
    public set regionName(v: string) {
        this._regionName = v;
    }

}
